var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8f8f8f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.057)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.057)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M276.252.506A1.041,1.041,0,0,0,275.358,0h-3.842V4.452h7.066Z",
    transform: "translate(-262.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.9,0H47.017a1.04,1.04,0,0,0-.9.507L43.8,4.452H50.9V0Z",
    transform: "translate(-43.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.057,156.648V167.9a1.255,1.255,0,0,0,1.266,1.24H47.791a1.255,1.255,0,0,0,1.266-1.24V156.648ZM43.5,161.38l-2.785,2.728a.546.546,0,0,1-.761,0l-1.306-1.279a.52.52,0,0,1,0-.746.547.547,0,0,1,.762,0l.924.906,2.4-2.356a.546.546,0,0,1,.761,0A.52.52,0,0,1,43.5,161.38Z",
    transform: "translate(-33.057 -151.141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.d7f716cc.svg";
export { ForwardRef as ReactComponent };